export const toggleMovileMenu = () => {
  document.body.classList.toggle('navigation-open');
}